var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "spinner_svg__loader-spinner-module",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20zm0 4c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
    fill: "#AFBBCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.745 2a2 2 0 012-2C37.017 0 48 10.31 48 24.255a2 2 0 01-4 0C44 12.69 34.983 4 22.745 4a2 2 0 01-2-2z",
    fill: "#262E3A"
  })));
}

export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QmpiR0Z6Y3owaWJHOWhaR1Z5TFhOd2FXNXVaWEl0Ylc5a2RXeGxJaUJtYVd4c1BTSnViMjVsSWlCNGJXeHVjejBpYUhSMGNEb3ZMM2QzZHk1M015NXZjbWN2TWpBd01DOXpkbWNpSUhacFpYZENiM2c5SWpBZ01DQTBPQ0EwT0NJK0NpQWdJQ0E4Y0dGMGFDQnZjR0ZqYVhSNVBTSXVNeUlnWm1sc2JDMXlkV3hsUFNKbGRtVnViMlJrSWlCamJHbHdMWEoxYkdVOUltVjJaVzV2WkdRaUNpQWdJQ0FnSUNBZ1pEMGlUVEkwSURRMFl6RXhMakEwTmlBd0lESXdMVGd1T1RVMElESXdMVEl3VXpNMUxqQTBOaUEwSURJMElEUWdOQ0F4TWk0NU5UUWdOQ0F5TkhNNExqazFOQ0F5TUNBeU1DQXlNRnB0TUNBMFl6RXpMakkxTlNBd0lESTBMVEV3TGpjME5TQXlOQzB5TkZNek55NHlOVFVnTUNBeU5DQXdJREFnTVRBdU56UTFJREFnTWpSek1UQXVOelExSURJMElESTBJREkwV2lJS0lDQWdJQ0FnSUNCbWFXeHNQU0lqUVVaQ1FrTkJJaUF2UGdvZ0lDQWdQSEJoZEdnZ1ptbHNiQzF5ZFd4bFBTSmxkbVZ1YjJSa0lpQmpiR2x3TFhKMWJHVTlJbVYyWlc1dlpHUWlDaUFnSUNBZ0lDQWdaRDBpVFRJd0xqYzBOU0F5WVRJZ01pQXdJREFnTVNBeUxUSkRNemN1TURFM0lEQWdORGdnTVRBdU16RWdORGdnTWpRdU1qVTFZVElnTWlBd0lEQWdNUzAwSURCRE5EUWdNVEl1TmprZ016UXVPVGd6SURRZ01qSXVOelExSURSaE1pQXlJREFnTUNBeExUSXRNbG9pQ2lBZ0lDQWdJQ0FnWm1sc2JEMGlJekkyTWtVelFTSWdMejRLUEM5emRtYysi";
export { SvgSpinner as ReactComponent };